import UpdateSalesDebitNote from "../../../../components/@documents/sales_debit_notes/UpdateSalesDebitNote";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesDebitNoteUpdatePage() {

    return (
        <UpdateSalesDebitNote 
            routeType={routeTypes.admin}
        />
    )
}